// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingOverlay_overlay__LUDEx {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  backdrop-filter: blur(2px);
}

.LoadingOverlay_inline__9lcVi {
  position: relative;
  inset: auto;
  min-height: 140px;
  border: 1px solid var(--cl-border);
  border-radius: 12px;
  background: var(--cl-surface);
}

.LoadingOverlay_compact__09wK1 {
  min-height: 80px;
}

.LoadingOverlay_spinner__F39tw {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid rgba(22, 119, 255, 0.2);
  border-top-color: #1677ff;
  animation: LoadingOverlay_spin__i\\+vn5 0.8s linear infinite;
}

.LoadingOverlay_text__wh4kg {
  font-size: 13px;
  opacity: 0.8;
}

@keyframes LoadingOverlay_spin__i\\+vn5 {
  to {
    transform: rotate(360deg);
  }
}
body[data-theme="dark"] .LoadingOverlay_overlay__LUDEx {
  background: rgba(23, 32, 45, 0.78);
}`, "",{"version":3,"sources":["webpack://./src/Components/Loading/LoadingOverlay.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EACA,2DAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE,kCAAA;AAAF","sourcesContent":[".overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.72);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  backdrop-filter: blur(2px);\n}\n\n.inline {\n  position: relative;\n  inset: auto;\n  min-height: 140px;\n  border: 1px solid var(--cl-border);\n  border-radius: 12px;\n  background: var(--cl-surface);\n}\n\n.compact {\n  min-height: 80px;\n}\n\n.spinner {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 3px solid rgba(22, 119, 255, 0.2);\n  border-top-color: #1677ff;\n  animation: spin 0.8s linear infinite;\n}\n\n.text {\n  font-size: 13px;\n  opacity: 0.8;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n:global(body[data-theme='dark']) .overlay {\n  background: rgba(23, 32, 45, 0.78);\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LoadingOverlay_overlay__LUDEx`,
	"inline": `LoadingOverlay_inline__9lcVi`,
	"compact": `LoadingOverlay_compact__09wK1`,
	"spinner": `LoadingOverlay_spinner__F39tw`,
	"spin": `LoadingOverlay_spin__i+vn5`,
	"text": `LoadingOverlay_text__wh4kg`
};
export default ___CSS_LOADER_EXPORT___;
